import * as React from 'react';
import Calculator from './Calculator/Calculator';
import ExampleTable from './ExampleTable/ExampleTable';
import FeatureList from './FeatureList/FeatureList';
import S from './FinanceCalculator.styles';
import TabList from './TabList/TabList';
const FinanceCalculator = (props) => {
    const [activeId, setActiveId] = React.useState(props.options[0].id);
    const activeOption = props.options.find((option) => option.id === activeId);
    return (React.createElement(S.Container, { id: props.anchorId },
        React.createElement(S.Title, null, props.title),
        React.createElement(S.Inner, null,
            React.createElement(TabList, { items: props.options, value: activeId, onChange: (id) => {
                    setActiveId(id);
                } }),
            React.createElement(S.FeaturesWrapper, null, props.options.map((option) => (React.createElement(FeatureList, { key: option.id, active: activeId === option.id, items: option.features })))),
            activeOption && (React.createElement("div", { key: activeOption.id },
                React.createElement(Calculator, { ...activeOption.calculator, optionId: activeOption.id }),
                React.createElement(S.BottomSection, null,
                    React.createElement(ExampleTable, { ...activeOption.example }),
                    React.createElement(S.LegalContent, { dangerouslySetInnerHTML: { __html: activeOption.legalContent } })))))));
};
export default FinanceCalculator;
